import React, { useState, useEffect } from 'react';
import { useParams, useLocation, Link, useNavigate } from 'react-router-dom';
import { getAnimeById, getPlayEpisode, getSeasonsByAnime, getEpisodesBySeason } from '../services/animeService';
import { useSelector } from 'react-redux';
import Loader from './Loader/Loader';
import { Play, Info, Calendar, Clock, UserCircle } from 'lucide-react';
import AnimePlayer from './AnimePlayer';

const AnimeDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const autoplay = searchParams.get('autoplay') === 'true';
  const autoplayEpisodeId = searchParams.get('episodeId');
  
  const [anime, setAnime] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedEpisode, setSelectedEpisode] = useState(null);
  const [playingEpisode, setPlayingEpisode] = useState(null);
  const [seasons, setSeasons] = useState([]);
  const [loadingSeasons, setLoadingSeasons] = useState(false);
  const [seasonsError, setSeasonsError] = useState(null);
  const [episodes, setEpisodes] = useState([]);
  const [loadingEpisodes, setLoadingEpisodes] = useState(false);
  const [episodesError, setEpisodesError] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(true);
  const [showAuthMessage, setShowAuthMessage] = useState(false);

  const renderAuthenticationMessage = () => (
    <div className="h-screen flex flex-col items-center justify-center bg-gradient-to-br from-black to-gray-900 p-4">
      <div className="bg-black/60 p-6 rounded-lg max-w-md text-center">
        <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
          <UserCircle className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-2xl font-bold mb-2 text-white">Acceso Exclusivo</h2>
        <p className="text-gray-300 mb-6">
          Para disfrutar de este contenido necesitas iniciar sesión o registrarte en nuestra plataforma.
        </p>
      </div>
    </div>
  );

  useEffect(() => {
    const fetchAnimeDetails = async () => {
      try {
        setLoading(true);
        const response = await getAnimeById(id);
        
        console.log('API response:', response);
        
        if (response && response.data) {
          console.log('Anime detallado:', response.data);
          
          // Agregar log detallado para seasons y episodes
          console.log('¿Tiene seasons?', !!response.data.seasons);
          if (response.data.seasons) {
            console.log('Número de temporadas:', response.data.seasons.length);
            console.log('Primera temporada:', response.data.seasons[0]);
            
            if (response.data.seasons.length > 0 && response.data.seasons[0].episodes) {
              console.log('Número de episodios en primera temporada:', response.data.seasons[0].episodes.length);
            } else {
              console.log('No hay episodios en la primera temporada o estructura incorrecta');
            }
          }
          
          // Cargar el anime
          setAnime(response.data);
          
          // Intentamos cargar las temporadas por separado
          await fetchSeasons(id);
        } else {
          setError('No se pudo cargar la información del anime');
        }
      } catch (err) {
        console.error('Error al obtener detalles del anime:', err);
        setError('Error al cargar los detalles del anime');
      } finally {
        setLoading(false);
      }
    };

    // Función para procesar el autoplay si se especifica en la URL
    const handleAutoplay = async () => {
      if (autoplay && autoplayEpisodeId) {
         setError(null);            // ← limpia el error rojo previo
setHasActiveSubscription(true); // ← vuelve a “asumir” que hay plan hasta saber lo contrario


        const token = localStorage.getItem('token');
        if (!token) {

          const nextPath = `/animes/${id}?autoplay=true&episodeId=${autoplayEpisodeId}`;
             localStorage.setItem('nextAfterLogin', nextPath);
             localStorage.removeItem('intendedPlaybackPath');
             localStorage.removeItem('intendedPlayback');
             setShowAuthMessage(true);
             return;




          // const nextPath = `/animes/${id}?autoplay=true&episodeId=${autoplayEpisodeId}`;
          // localStorage.setItem('intendedPlayback', JSON.stringify({
          //   path: nextPath, ts: Date.now(),
          // }));
          // setShowAuthMessage(true);
          // return;
        }
        console.log('Reproducción automática solicitada para el episodio:', autoplayEpisodeId);
        try {
          const response = await getPlayEpisode(autoplayEpisodeId);
          console.log('Respuesta de episodio para autoplay:', response);
          
          if (response && response.success && response.data) {
            // Buscar a qué temporada pertenece este episodio y seleccionarla
            const episodeData = response.data;
            if (episodeData.seasonId) {
              // Esto establecerá la temporada seleccionada y cargará sus episodios
              const seasonResponse = await getSeasonsByAnime(id);
              if (seasonResponse && seasonResponse.success && seasonResponse.data) {
                const targetSeason = seasonResponse.data.find(s => s.id === episodeData.seasonId);
                if (targetSeason) {
                  console.log('Seleccionando temporada para autoplay:', targetSeason);
                  setSelectedSeason(targetSeason);
                  
                  // Cargamos los episodios para mostrarlos en la interfaz
                  await loadEpisodesForSeason(targetSeason.id);
                }
              }
            }
            
            // Reproducir el episodio
            setSelectedEpisode(episodeData);
            setPlayingEpisode({
              ...episodeData,
              videoUrl: episodeData.videoUrl,
              srtUrl: episodeData.srtUrl
            });
            
            // Desplazar la vista al reproductor
            setTimeout(() => {
              const videoElement = document.getElementById('episode-player');
              if (videoElement) {
                videoElement.scrollIntoView({ behavior: 'smooth' });
              }
            }, 500);
          } else {
            setError('No se pudo cargar el episodio para reproducción automática');
          }
        } catch (err) {
          console.error('Error al procesar autoplay:', err);
            const status = err?.response?.status;
             const reason = err?.response?.data?.reason;
             // Si no tiene plan activo → NO setees error (para evitar el cartel rojo)
             if (status === 403 || reason === 'subscription_required' || reason === 'inactive_subscription') {
               setHasActiveSubscription(false);
               const subs = err?.response?.data?.subscriptions || [];
               setSubscriptions(Array.isArray(subs) ? subs : []);
               return; // mostramos el modal de suscripción requerida
             }
             // Otros errores sí muestran el cartel rojo
             setError('Error al reproducir episodio automáticamente');


          // console.error('Error al procesar autoplay:', err);
          // setError('Error al reproducir episodio automáticamente');
        }
      }
    };

    const saved = localStorage.getItem('intendedPlayback');
    if (saved) {
      const { path } = JSON.parse(saved);
      const here = `${location.pathname}${location.search}`;
      if (path === here) localStorage.removeItem('intendedPlayback');
    }

    const fetchSeasons = async (animeId) => {
      try {
        setLoadingSeasons(true);
        setSeasonsError(null);
        
        console.log('Cargando temporadas para anime ID:', animeId);
        const seasonsResponse = await getSeasonsByAnime(animeId);
        
        console.log('Respuesta de temporadas:', seasonsResponse);
        
        if (seasonsResponse && seasonsResponse.data) {
          console.log('Temporadas cargadas:', seasonsResponse.data);
          setSeasons(seasonsResponse.data);
          
          // Si hay temporadas, seleccionar la primera por defecto y cargar sus episodios
          if (seasonsResponse.data.length > 0) {
            const firstSeason = seasonsResponse.data[0];
            setSelectedSeason(firstSeason);
            
            // Cargar automáticamente los episodios de la primera temporada
            try {
              await loadEpisodesForSeason(firstSeason.id);
            } catch (episodeErr) {
              console.error('Error al cargar episodios de la primera temporada:', episodeErr);
              // No establecer error aquí para evitar bloquear la interfaz
            }
          }
        } else {
          console.warn('No se encontraron temporadas para este anime');
        }
      } catch (err) {
        console.error('Error al cargar temporadas:', err);
        setSeasonsError('No se pudieron cargar las temporadas del anime');
      } finally {
        setLoadingSeasons(false);
      }
    };

    if (id) {
      fetchAnimeDetails().then(() => {
        // Solo procesamos el autoplay después de cargar los detalles del anime
        handleAutoplay();
      });
    }
  }, [id, autoplay, autoplayEpisodeId]);

  const handleSeasonSelect = async (season) => {
    setSelectedSeason(season);
    setSelectedEpisode(null);
    setPlayingEpisode(null);
    
    // Cargar episodios de la temporada seleccionada
    await loadEpisodesForSeason(season.id);
  };

  // Nueva función para cargar episodios de una temporada
  const loadEpisodesForSeason = async (seasonId) => {
    try {
      setLoadingEpisodes(true);
      setEpisodesError(null);
      setEpisodes([]);
      
      console.log('Cargando episodios para la temporada ID:', seasonId);
      const response = await getEpisodesBySeason(seasonId);
      
      console.log('Respuesta de episodios:', response);
      
      if (response && response.success && response.data) {
        console.log('Episodios cargados:', response.data);
        setEpisodes(response.data);
      } else {
        console.warn('No se encontraron episodios para esta temporada');
        setEpisodes([]);
      }
    } catch (err) {
      console.error('Error al cargar episodios:', err);
      setEpisodesError('No se pudieron cargar los episodios');
    } finally {
      setLoadingEpisodes(false);
    }
  };

  const handleEpisodeSelect = (episode) => {
    setSelectedEpisode(episode);
  };

  const handlePlayEpisode = async (episode) => {
    try {
      //setLoading(true);
      console.log('Solicitando reproducción para episodio ID:', episode.id);
      console.log('Datos del episodio antes de la petición:', episode);
      
      // Verificar token
      const token = localStorage.getItem('token');
      console.log('Token de autenticación disponible:', !!token);
      
      if(!token) {
        // const nextPath = `/animes/${id}?autoplay=true&episodeId=${episode.id}`;
        // localStorage.setItem('intendedPlayback', JSON.stringify({
        //   animeId: id, episodeId: episode.id, path: nextPath, ts: Date.now(),
        // }));
        //navigate(`/login?next=${encodeURIComponent(nextPath)}`);

        // const nextPath = `/animes/${id}?autoplay=true&episodeId=${episode.id}`;
        // localStorage.setItem('intendedPlayback', nextPath);
        // localStorage.removeItem("intendedPlayback", JSON.stringify({
        //   path: nextPath, ts: Date.now(),
        // }));

        // setShowAuthMessage(true);
        // setLoading(false);
        // return;



        const nextPath = `/animes/${id}?autoplay=true&episodeId=${episode.id}`;
           // estándar único
           localStorage.setItem('nextAfterLogin', nextPath);
           // (compat) limpia claves viejas para que no ganen prioridad en login
           localStorage.removeItem('intendedPlaybackPath');
           localStorage.removeItem('intendedPlayback');
           setShowAuthMessage(true); // mostrás el mensaje y usás el botón del Header para ir a /login
           setLoading(false);
        return;



      }
      
      const response = await getPlayEpisode(episode.id);
      
      console.log('Play episode response completo:', response);
      
      // El backend devuelve la respuesta como {success: true, data: episode}
      if (response && response.success && response.data) {
        const episodeData = response.data;
        console.log('Datos del episodio de la respuesta:', episodeData);
        
        // Verificar si los datos contienen videoUrl
        if (episodeData.videoUrl) {
          console.log('URL del video obtenida:', episodeData.videoUrl);
          setPlayingEpisode({
            ...episode,
            videoUrl: episodeData.videoUrl,
            srtUrl: episodeData.srtUrl
          });
          console.log('Episodio listo para reproducción:', {
            ...episode,
            videoUrl: episodeData.videoUrl,
            srtUrl: episodeData.srtUrl
          });
        } else {
          console.error('No se encontró videoUrl en los datos del episodio:', episodeData);
          setError('El episodio no contiene una URL de video válida');
        }
      } else {
        console.error('La respuesta no contiene la estructura esperada:', response);
        
        // Intentar buscar la URL en otra parte de la respuesta si existe
        if (response) {
          console.log('Estructura de la respuesta:', Object.keys(response));
          
          // Intentar directamente desde la raíz de la respuesta
          if (response.videoUrl) {
            console.log('URL alternativa encontrada en la raíz:', response.videoUrl);
            setPlayingEpisode({
              ...episode,
              videoUrl: response.videoUrl,
              srtUrl: response.srtUrl || episode.srtUrl
            });
            return;
          }
          
          // Si hay un objeto data pero no tiene la estructura esperada
          if (response.data) {
            console.log('Intentando buscar URL en response.data');
            
            if (typeof response.data === 'string') {
              // Si data es una string, quizás es directamente la URL
              console.log('response.data es una string, usándola como URL');
              setPlayingEpisode({
                ...episode,
                videoUrl: response.data,
                srtUrl: episode.srtUrl
              });
              return;
            }
            
            // Si data es un objeto
            if (response.data.videoUrl) {
              console.log('URL encontrada en response.data.videoUrl:', response.data.videoUrl);
              setPlayingEpisode({
                ...episode,
                videoUrl: response.data.videoUrl,
                srtUrl: response.data.srtUrl || episode.srtUrl
              });
              return;
            }
          }
        }
        
        setError('No se pudo cargar el episodio para reproducción (estructura de respuesta inválida)');
      }
    } catch (err) {
      console.error('Error al reproducir episodio:', err);
      if (err.response) {
        console.error('Detalles del error:', err.response.status, err.response.data);
        
        // Verificar si el error es 403 (falta de suscripción)
        if (err.response.status === 403) {
          console.log('Error de suscripción no activa');
          setHasActiveSubscription(false);
          // Obtener las suscripciones del usuario si las hay
          if (err.response.data && err.response.data.subscriptions) {
            setSubscriptions(err.response.data.subscriptions);
          }
          return;
        }
      }
      setError('Error al cargar el episodio para reproducción: ' + (err.message || 'Error desconocido'));
    } finally {
      setLoading(false);
    }
  };

  // Renderiza el mensaje de suscripción requerida
  const renderNoSubscriptionMessage = () => {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black/80 z-50">
        <div className="bg-black/60 p-6 rounded-lg max-w-md text-center">
          <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <Play size={16} fill="white" stroke="white" />
          </div>
          <h2 className="text-2xl font-bold mb-2 text-white">Suscripción Requerida</h2>
          <p className="text-gray-300 mb-4">
            Necesitas tener una suscripción dentro del periodo de vigencia para reproducir episodios de anime.
          </p>
          {subscriptions && subscriptions.length > 0 ? (
            <div className="mb-4 text-left text-sm bg-gray-800/50 p-3 rounded">
              <p className="font-semibold text-white mb-1">Estado de tus suscripciones:</p>
              {subscriptions.map(sub => (
                <div key={sub.id} className="mb-2 text-gray-300">
                  <p>
                    • Estado: <span className={sub.status === 'active' ? 'text-green-400' : 'text-red-400'}>{sub.status}</span>
                  </p>
                  <p>• Válida: {new Date(sub.startDate).toLocaleDateString()} a {new Date(sub.endDate).toLocaleDateString()}</p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-400 mb-4">No tienes ninguna suscripción registrada.</p>
          )}
          <Link
            to="/subscriptionplan"
            className="block w-full bg-yellow-500 hover:bg-yellow-400 text-black font-medium py-2 px-4 rounded transition-colors"
          >
            Ver planes disponibles
          </Link>
        </div>
      </div>
    );
  };

  if (loading && !anime) {
    return <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
    </div>;
  }

  if (error && !hasActiveSubscription) {
    return renderNoSubscriptionMessage();
  }

  if (error && !loading) {
    return <div className="flex justify-center items-center h-screen">
      <div className="bg-red-900/50 border border-red-500 text-white p-8 rounded-md max-w-xl">
        <h2 className="text-xl font-bold mb-2">Error</h2>
        <p>{error}</p>
      </div>
    </div>;
  }

  if(showAuthMessage) {
    return renderAuthenticationMessage();
  }
  return (
    <div className="anime-detail-container bg-gray-900 text-white min-h-screen p-6 relative">
      {!hasActiveSubscription && renderNoSubscriptionMessage()}
      
      {!loading && anime && (
        <div>
          {/* Hero Banner con Gradiente al estilo Netflix */}
          <div 
            className="relative w-full h-[50vh] bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${anime.banner || anime.poster})`,
              backgroundPosition: 'center 20%'
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black"></div>
            
            {/* Contenido del Hero */}
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="container mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold mb-4">{anime.name}</h1>
                
                <div className="flex flex-wrap gap-2 mb-4 text-sm text-gray-300">
                  {anime.releaseYear && (
                    <span className="flex items-center">
                      <Calendar size={16} className="mr-1" />
                      {anime.releaseYear}
                    </span>
                  )}
                  <span className="px-1 border border-gray-500">12+</span>
                  <span>{anime.totalSeasons || (seasons && seasons.length)} Temporadas</span>
                  <span className="px-1 border border-gray-500">HD</span>
                </div>
                
                <div className="max-w-2xl mb-6">
                  <p className="text-base">{anime.description}</p>
                </div>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="text-gray-400">Géneros: </span>
                  {anime.genre && typeof anime.genre === 'string' && anime.genre.split(',').map((genre, idx) => (
                    <span key={idx} className="text-white">
                      {genre.trim()}{idx < anime.genre.split(',').length - 1 ? ',' : ''}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Reproductor de video (si hay un episodio en reproducción) */}
          {playingEpisode && (
            <div className="container mx-auto px-4 py-8">
              <h2 className="text-2xl font-bold text-white mb-4">
                {playingEpisode.name}
              </h2>
              
              {/* Componente AnimePlayer con las propiedades correctas */}
              <AnimePlayer 
                episode={playingEpisode}
                anime={anime}
              />
              
              <div className="mt-6">
                <h3 className="text-xl font-semibold mb-2">{playingEpisode.name}</h3>
                <p className="text-gray-300">{playingEpisode.description}</p>
              </div>
            </div>
          )}

          <div className="container mx-auto px-4 py-8">
            {/* Mensaje de carga de temporadas */}
            {loadingSeasons && (
              <div className="flex items-center text-gray-300 mb-4">
                <div className="animate-spin mr-2 h-4 w-4 border-t-2 border-b-2 border-red-600 rounded-full"></div>
                Cargando temporadas...
              </div>
            )}

            {/* Mensaje de error al cargar temporadas */}
            {seasonsError && (
              <div className="bg-red-900/50 border border-red-500 text-white p-4 rounded-md mb-4">
                {seasonsError}
              </div>
            )}

            {/* Selector de temporadas (usando las temporadas cargadas independientemente) */}
            {seasons && seasons.length > 0 && (
              <div className="mb-8">
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <span className="p-2 rounded-full bg-red-600 mr-2 inline-flex items-center justify-center">
                    <Play size={16} fill="white" stroke="white" />
                  </span>
                  Temporadas
                </h2>
                <div className="max-w-xs">
                  <select
                    onChange={(e) => {
                      const selectedSeasonId = parseInt(e.target.value);
                      const season = seasons.find(s => s.id === selectedSeasonId);
                      if (season) {
                        handleSeasonSelect(season);
                      }
                    }}
                    value={selectedSeason?.id || ''}
                    className="w-full bg-gray-800 text-white p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  >
                    <option value="" disabled>Seleccionar Temporada</option>
                    {seasons.map((season) => (
                      <option key={season.id} value={season.id}>
                        {season.title || `Temporada ${season.seasonNumber}`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {/* Lista de episodios */}
            {selectedSeason && (
              <div>
                <h2 className="text-2xl font-bold mb-6 flex items-center">
                  <span className="p-2 rounded-full bg-gray-700 mr-2 inline-flex items-center justify-center">
                    <Info size={16} className="text-white" />
                  </span>
                  Episodios
                </h2>
                
                {/* Mensaje de carga de episodios */}
                {loadingEpisodes && (
                  <div className="flex items-center text-gray-300 mb-4">
                    <div className="animate-spin mr-2 h-4 w-4 border-t-2 border-b-2 border-red-600 rounded-full"></div>
                    Cargando episodios...
                  </div>
                )}
                
                {/* Mensaje de error al cargar episodios */}
                {episodesError && (
                  <div className="bg-red-900/50 border border-red-500 text-white p-4 rounded-md mb-4">
                    {episodesError}
                  </div>
                )}
                
                {!loadingEpisodes && episodes.length === 0 && !episodesError && (
                  <p className="text-gray-300 py-4 text-center">No hay episodios disponibles para esta temporada.</p>
                )}
                
                {episodes.length > 0 && (
                  <div className="space-y-4">
                    {episodes.map((episode) => (
                      <div 
                        key={episode.id}
                        className="bg-gray-900 hover:bg-gray-800 rounded-lg overflow-hidden cursor-pointer transition-colors duration-300 border border-gray-800"
                        onClick={() => {
                          handleEpisodeSelect(episode);
                          handlePlayEpisode(episode);
                        }}
                      >
                        <div className="flex flex-col md:flex-row">
                          <div className="md:w-1/3 lg:w-1/4 relative">
                            <img 
                              src={episode.poster || anime.poster || 'https://via.placeholder.com/300x200.png?text=Sin+imagen'} 
                              alt={episode.name}
                              className="w-full h-full object-cover aspect-video"
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity">
                              <div className="p-3 rounded-full bg-red-600/80">
                                <Play fill="white" className="w-8 h-8" />
                              </div>
                            </div>
                          </div>
                          <div className="p-4 md:w-2/3 lg:w-3/4">
                            <div className="flex justify-between items-start">
                              <h3 className="font-bold text-lg">{episode.name}</h3>
                              <span className="text-sm text-gray-400 flex items-center">
                                <Clock size={14} className="mr-1" />
                                {Math.floor(episode.runtime / 60)}m {episode.runtime % 60}s
                              </span>
                            </div>
                            <p className="mt-2 text-gray-400 text-sm line-clamp-2">
                              {episode.description || `Episodio ${episode.episodeNumber} de la temporada ${selectedSeason.seasonNumber}`}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      
      {loading && <Loader />}
    </div>
  );
};

export default AnimeDetail;
